// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kEgx3R {
  &.KHJ3Qi {
    min-width: 767px;
  }
}

.u8ErNW {
  font-size: var(--font-size-md);
  margin-bottom: var(--spacing-3, 24px);
}

.Z8gIi1 {
  margin-top: var(--spacing-3, 24px);
  display: flex;
  gap: var(--spacing-2, 12px);
  justify-content: space-around;
}

.xJBo8U {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 20px);
}

.VQpgrt {
  flex-grow: 1;
  &:first-of-type {
    color: var(--button-primary-text) !important;
    border-color: var(--button-primary-text) !important;
  }
  &:last-of-type {
    background-color: var(--button-primary-text);
  }
}

.ViExJM {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/contabilidade-digital/src/pages/ContabilidadeDigitalDasboard/components/ConsentModal/ConsentModal.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ;IACE,4CAA4C;IAC5C,mDAAmD;EACrD;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".modal {\n  &.modalWidget {\n    min-width: 767px;\n  }\n}\n\n.description {\n  font-size: var(--font-size-md);\n  margin-bottom: var(--spacing-3, 24px);\n}\n\n.buttonContainer {\n  margin-top: var(--spacing-3, 24px);\n  display: flex;\n  gap: var(--spacing-2, 12px);\n  justify-content: space-around;\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 20px);\n}\n\n.button {\n  flex-grow: 1;\n  &:first-of-type {\n    color: var(--button-primary-text) !important;\n    border-color: var(--button-primary-text) !important;\n  }\n  &:last-of-type {\n    background-color: var(--button-primary-text);\n  }\n}\n\n.loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `kEgx3R`,
	"modalWidget": `KHJ3Qi`,
	"description": `u8ErNW`,
	"buttonContainer": `Z8gIi1`,
	"formContainer": `xJBo8U`,
	"button": `VQpgrt`,
	"loading": `ViExJM`
};
module.exports = ___CSS_LOADER_EXPORT___;
